<template>
  <div
    v-if="active"
    ref="sentinel"
    class="text-center q-pa-sm"
  >
    <q-spinner
      v-if="loading"
      color="primary"
      size="24px"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['load-more'],
  props: {
    active: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      observer: null as IntersectionObserver | null,
    };
  },
  watch: {
    active() {
      this.$nextTick(() => this.setup());
    },
  },
  mounted() {
    this.setup();
  },
  beforeUnmount() {
    this.teardown();
  },
  methods: {
    setup() {
      this.teardown();
      const el = this.$refs.sentinel as HTMLElement | undefined;
      if (!el) return;
      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            this.$emit('load-more');
          }
        },
        { threshold: 0.1 },
      );
      this.observer.observe(el);
    },
    teardown() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    },
  },
});
</script>
